import { useAtom } from 'jotai';
import { useSetStoreName } from '../../../store/appStore';
import { selectedSuggestionAtom } from '../atoms';

export function useStoreNameInput() {
  const setStoreName = useSetStoreName();
  const [selectedSuggestion, setSelectedSuggestion] = useAtom(selectedSuggestionAtom);

  function handleStoreNameChange(newValue: string) {
    setStoreName(newValue);
    if (selectedSuggestion && newValue !== selectedSuggestion) {
      setSelectedSuggestion('');
    }
  }

  function handleSuggestionSelect(option: { value: string; label: string }) {
    setStoreName(option.value);
    setSelectedSuggestion(option.value);
  }

  return {
    handleStoreNameChange,
    handleSuggestionSelect,
  };
}
